export const environment = {
  activarRecaptcha: true,
  production: true,
  testing: false,
  version: '2.0.0',
  googleAnalyticsId: 'UA-129276675-2',
  apiUrl: 'https://ginni.pandero.com.pe',
  seguimientoApiUrl: 'https://aplicacionesrapidas.pandero.com.pe/SeguimientoContratoResuelto/form_FID_ReactivacionContrato_ginni'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts